import { RESOURCES } from '../config/resources';

export enum POST_TYPES {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
  POLL = 'POLL',
  GIF = 'GIF',
  DOB = 'DOB',
  DOJ = 'DOJ',
  WELCOME = 'WELCOME'
}

export enum ACTION_TYPES {
  POST_LIKE = 'POST_LIKE',
  POST_COMMENT = 'POST_COMMENT',
  POST_SAVE = 'POST_SAVE',
  POST_REPORT = 'POST_REPORT',
  POST_VIEW = 'POST_VIEW',
  POST_VOTE = 'POST_VOTE',
  COMMENT_REPORT = 'COMMENT_REPORT',
  USER_FOLLOW = 'USER_FOLLOW',
  USER_VIEW = 'USER_VIEW',
  USER_REPORT = 'USER_REPORT',
  USER_BLOCK = 'USER_BLOCK',
  GROUP_FOLLOW = 'GROUP_FOLLOW',
  PROJECT_INVITE = 'PROJECT_INVITE',
  PROJECT_COMMENT = 'PROJECT_COMMENT',
  PAGE_COMMENT = 'PAGE_COMMENT',
  FORM_COMMENT = 'FORM_COMMENT'
}

export enum ACTION_STATUS {
  READ = 'READ',
  UNREAD = 'UNREAD',
  DELETED = 'DELETED'
}

export const ALLOWED_NOTIFICATIONS = [
  ACTION_TYPES.POST_LIKE,
  ACTION_TYPES.POST_COMMENT,
  ACTION_TYPES.USER_FOLLOW,
  ACTION_TYPES.GROUP_FOLLOW,
  ACTION_TYPES.PROJECT_INVITE,
  ACTION_TYPES.PROJECT_COMMENT
];

export enum UPLOAD_TYPES {
  TIMELINE = 'timeline',
  CHATS = 'chats',
  GROUPS = 'groups',
  PROJECTS = 'projects',
  POLICIES = 'policies',
  USERS = 'users',
  DOCUMENTS = 'documents'
}

export enum POST_STATUS {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE'
}

export interface DIMENSIONS {
  width?: any;
  height?: any;
  size?: any;
  duration?: any;
}

export interface POST {
  uuid: string;
  title: string;
  type: string;
  userUuid: string;
  file: string;
  fileName: string;
  name: string;
  username: string;
  image?: string;
  dimensions?: DIMENSIONS;
  created: string;
  likes: number;
  comments: number;
  isLiked: number;
  isSaved: number;
}

export interface CHOICES {
  id: number;
  choice: string;
  votes: number;
}

export enum POST_PRIVACY {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}

export const POST_EVENT_IMAGES = {
  [POST_TYPES.DOB]: RESOURCES.WORK_BIRTHDAY,
  [POST_TYPES.DOJ]: RESOURCES.WORK_ANIVERSARY,
  [POST_TYPES.WELCOME]: RESOURCES.WORK_WELCOME
};
